import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useFetchAgentMasters = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("agentMaster/list?agentMasterId=" + data.agentMasterId );
    }, options);
};